import React from "react";
import { useIntl } from "react-intl";
import Swal from "sweetalert2";
export default function useToast() {
    const { formatMessage } = useIntl();
    const toast = React.useCallback((idText, data = {}) => {
        Swal.fire({
            title: formatMessage({ id: idText }, data),
            toast: true,
            timer: 3000,
            icon: "success",
            position: "top-end",
            showConfirmButton: false,
            showCloseButton: true,
            timerProgressBar: true,
            customClass: { popup: "!rounded-xl !shadow-overlay" },
        });
    }, [formatMessage]);
    return { toast: toast };
}
//# sourceMappingURL=useToast.jsx.map